'use strict'

const BaseAnalyticsBuilder = require('./baseAnalyticsBuilder');

const CONSTANTS = require('../constants/constants');
const EventHelper = require('../helpers/eventHelper');
const SearchResultPageEventHelper = require('../helpers/searchResultPageEventHelper');

class ListingAnalyticsBuilder extends BaseAnalyticsBuilder{

  constructor() {
    super();
  }

  /**
   * This function will attach analytics events to current page
   */
  attachAnalytics() {
    //Attach base events
    super.attachAnalytics();

    //Attach all detail page triggers
    this.attachSpecificTriggers();

    // attach view list items event on scroll and on render
    if(typeof window.dataLayer != 'undefined'){
      var _plpScrollTimer;
      $(window).on('scroll', function() {
        if (_plpScrollTimer) return;
        _plpScrollTimer = setTimeout(function() {
          _plpScrollTimer = null;
          EventHelper.editorialViewItemList();
        }, 100);
      });

      // On Render
      EventHelper.editorialViewItemList();
    }
  }

  /**
   * This function exposes triggers to element inside current page
   */
  attachSpecificTriggers(){

    //Trigger first search view event
    $(document).trigger(CONSTANTS.EVENT_CONSTANTS.PLP.EVENTS.FIRE_FIRST_SEARCH);

    //Filters event
    $(document).on(CONSTANTS.EVENT_CONSTANTS.PLP.EVENTS.FIRE_FILTERS, useFilter);

    // SRP generic_event — abilita un punto alla volta in searchResultPageEventHelper.js
    SearchResultPageEventHelper.attachSearchResultPageAnalytics();

  }

}

/**
 * Private functions
 */

/**
 * Internal filter push function
 * @param element
 * @param type
 */
function pushFilterEvent(element, type, value){
  if(typeof dataLayer !== 'undefined'){
        
    dataLayer.push({
      event : CONSTANTS.EVENT_LIST_NAME.USE_FILTER.BASE,
      filter_applied : value,
      filter_category : element,
      filter_action : type
    });
  }
}


/**
 * This function handles filter usage event.
 * Trigger this event after BE successful response.
 * WARNING: if filter is added without FE interaction, this function will ignore it
 * @param event
 * @param data
 */
function useFilter(event, data){

  if(data && data.addedFilters){
    var addedFilters = data.addedFilters;
    if(addedFilters.length > 0){
      addedFilters.forEach(function(element){
        pushFilterEvent(element, CONSTANTS.EVENT_LIST_NAME.USE_FILTER.ADD, data.value);
      })
    }
  }

  if(data && data.removedFilters){
    var removedFilters = data.removedFilters;
    if(removedFilters.length > 0){
      removedFilters.forEach(function(element){
        pushFilterEvent(element, CONSTANTS.EVENT_LIST_NAME.USE_FILTER.REMOVE, data.value);
      })
    }
  }
}

module.exports = ListingAnalyticsBuilder;
